<script>
  import MaxButton from '@maxcomponents/MaxButton.vue';

  export default {
    name: 'NotFound',

    components: { MaxButton },

    mounted() {
      document.body.classList.add('not-found-page');
    },

    beforeDestroy() {
      document.body.classList.remove('not-found-page');
    },
  };
</script>

<template>
  <div class="not-found">
    <img src="/images/maxduel/404/background.webp" alt="Background" />
    <span>Error 404</span>
    <h1>Page Not Found</h1>
    <p>The page you are looking for might have been removed or is temporarily unavailable</p>
    <MaxButton icon="arrowLeftCircle" @click="$router.push('/')">Go Back</MaxButton>
  </div>
</template>

<style scoped lang="scss">
  .not-found {
    width: 100%;
    height: 100%;

    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    padding: 20px;

    :not(img) {
      color: #fff;
      position: relative;
    }

    span {
      font-size: 24px;
      font-weight: 700;
    }

    h1 {
      font-size: 80px;
    }

    p {
      font-size: 32px;
      font-weight: 500;
      line-height: 1.5;
    }

    @include respond(mobile-wide-down) {
      span {
        font-size: 20px;
      }
      h1 {
        font-size: 60px;
      }
      p {
        font-size: 24px;
        margin-top: 24px;
      }
    }

    img {
      object-fit: cover;
      position: fixed;
      width: 100%;
      height: 100%;
      left: 0;
      top: 0;
      @include respond(mobile-wide-down) {
        max-width: 100vh;
        max-height: 100vw;
        transform: translatex(calc(50vw - 50%)) translatey(calc(50vh - 50%)) rotate(-90deg);
        width: 100vh;
        height: 100vw;
      }
    }
  }
</style>
